// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2prlv","content":"styles_content__2x4eX","row":"styles_row__21AgS","footer":"styles_footer__BenGq","phraseLength":"styles_phraseLength__2Be8u"};